import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { CtaBanner } from "@/components/CtaBanner";
import { PROCESS_STEPS } from "@/config/site";

export default function ProcessPage() {
  return (
    <>
      <Seo
        title="Our Process: Discovery to Support | Tedmo Services"
        description="How Tedmo Services delivers: Discovery, Design, Build, Deploy, Support — a transparent process from first conversation to long-term maintenance."
        path="/process"
      />

      <section className="py-20 border-b border-line" data-testid="process-hero">
        <div className="max-w-6xl mx-auto px-6">
          <span className="font-mono-sub text-xs text-royal uppercase tracking-wider font-bold">
            Standard Workflow
          </span>
          <h1
            data-testid="process-page-title"
            className="font-poster text-4xl sm:text-5xl font-extrabold text-steel mt-2 max-w-3xl leading-tight"
          >
            Discovery → Design → Build → Deploy → Support
          </h1>
          <p className="text-lg text-ink mt-6 max-w-2xl leading-relaxed">
            A predictable process with no black boxes. You always know what is
            happening, what comes next, and what you will receive.
          </p>
        </div>
      </section>

      <section className="py-20 max-w-4xl mx-auto px-6" data-testid="process-steps">
        <ol className="relative border-l border-line ml-3 space-y-12">
          {PROCESS_STEPS.map((step, i) => (
            <Reveal key={step.name} delay={i * 60}>
              <li data-testid={`process-detail-${step.name.toLowerCase()}`} className="pl-8 relative">
                <span className="absolute -left-[22px] top-0 w-11 h-11 rounded-lg bg-royal text-white font-mono-sub font-bold text-sm flex items-center justify-center">
                  0{i + 1}
                </span>
                <h2 className="font-poster text-2xl font-bold text-steel pl-4">{step.name}</h2>
                <p className="text-sm text-ink mt-2 pl-4 leading-relaxed">{step.detail}</p>
                <p className="text-xs font-mono-sub text-royal mt-3 pl-4">
                  You get: {step.deliverable}
                </p>
              </li>
            </Reveal>
          ))}
        </ol>
      </section>

      <CtaBanner title="Start with Discovery — tell us about your project" />
    </>
  );
}
